import React, { useContext, useState } from "react";
import { Button, Steps, theme } from "antd";
import { useNavigate } from "react-router";
import { context } from "../context/context";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { toast } from "react-toastify";
import GalleryForm from "../components/Gallery/GalleryForm";
import GalleryUploadMedia from "../components/Gallery/GalleryUploadMedia";
import { NavLink } from "react-router-dom";

const steps = [
    {
        title: "اضافه کردن جزئیات رویداد",
        content: <GalleryForm />,
    },
    {
        title: "انتخاب عکس",
        content: <GalleryUploadMedia />,
    },
];
const EditGallery = () => {
    const { token } = theme.useToken();
    // state
    const [current, setCurrent] = useState(0);
    // context
    const {
        setGalleryMedia,
        galleryDescription,
        galleryTitle,
        galleryColor,
        galleryIcon,
        galleryMediaId,
        galleryTags,
        setGalleryMediaId,
        selectedGalleryId,
    } = useContext(context);

    // functions
    const next = () => {
        setCurrent(current + 1);
    };
    const navigate = useNavigate();
    const handleSubmit = () => {
        http.post(
            `${config.parkopoloApi}/api/Gallery/editGallery/${selectedGalleryId}`,
            {
                description: galleryDescription,
                title: galleryTitle,
                color: galleryColor,
                icon: galleryIcon,
                media: galleryMediaId,
                tags: galleryTags,
            }
        )
            .then((res) => {
                toast.success("نگارخانه با موفقیت ویرایش شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setGalleryMedia([]);
        setGalleryMediaId([]);
        navigate("/gallery", { replace: true });
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        lineHeight: "260px",
        textAlign: "center",
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };
    return (
        <div style={{ direction: "ltr" }}>
            <Steps current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                    textAlign: "left",
                    display: "flex",
                    gap: 10,
                }}
            >
                {current < steps.length - 1 && (
                    <Button
                        type="primary"
                        onClick={() => next()}
                        disabled={
                            current === 0 &&
                            (!galleryTitle || galleryTitle === "")
                        }
                    >
                        مرحله بعد
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button
                        disabled={galleryMediaId.length === 0}
                        type="primary"
                        onClick={() => handleSubmit()}
                    >
                        ثبت
                    </Button>
                )}
                {
                    <NavLink to="/gallery">
                        <Button type="primary" danger>
                            لغو
                        </Button>
                    </NavLink>
                }
            </div>
        </div>
    );
};

export default EditGallery;
